import React from 'react';
import Layout from '../components/Layout/Layout';

// Import blood donation images
import bannerImg from '../images/blood-donationcamp-header.jpg';
import img1 from '../images/blood-1.jpeg';
import img2 from '../images/blood-2.jpeg';
import img3 from '../images/blood-3.jpg';
import img4 from '../images/blood-4.jpg';
import img5 from '../images/blood-5.jpeg';
import img6 from '../images/blood-7.jpeg';
import img7 from '../images/blood-8.jpg';
import img8 from '../images/blood-2.jpeg'; // Reusing as filler if needed

const BloodDonationPage = () => {
  const images = [
    { title: 'Registration Desk', image: img1 },
    { title: 'Donors contributing', image: img2 },
    { title: 'Medical team assistance', image: img3 },
    { title: 'Volunteers guiding', image: img4 },
    { title: 'Post-donation refreshment', image: img5 },
    { title: 'A moment of generosity', image: img1 }, // Repurposing if samples are few
    { title: 'Another camp moment', image: img7 },
    { title: 'More volunteers', image: img8 }
  ];

  return (
    <Layout>
      <div id="blood-donation" className="page-container" style={{ maxWidth: '1000px', margin: '40px auto', padding: '0 20px', minHeight: '500px' }}>
        
        <h2 style={{ color: '#004d99', borderBottom: '1px solid #90cdf4', paddingBottom: '20px', marginBottom: '30px', textAlign: 'center', fontSize: '2.5rem', fontWeight: 'bold' }}>
          Gallery - Blood Donation Camp
        </h2>

        <div style={{ marginBottom: '40px', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
          <img src={bannerImg} alt="Blood Donation Camp Banner" style={{ width: '100%', height: 'auto', display: 'block' }} />
        </div>

        <p style={{ color: '#444', marginBottom: '40px', lineHeight: '1.6', fontSize: '1.05rem', textAlign: 'left' }}>
          Further details on camp impact: Photos also include moments of medical professionals ensuring a safe and efficient donation process.
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(450px, 1fr))',
          gap: '20px',
          marginBottom: '40px'
        }}>
          {images.map((item, index) => (
            <div key={index} style={{
              backgroundColor: '#fff',
              borderRadius: '8px',
              overflow: 'hidden',
              boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
              border: '1px solid #e2e8f0'
            }}>
              <div style={{ height: '350px', overflow: 'hidden' }}>
                <img 
                  src={item.image} 
                  alt={item.title} 
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                />
              </div>
              <div style={{ 
                backgroundColor: '#f1f5f9', 
                padding: '15px', 
                textAlign: 'center', 
                fontSize: '1rem', 
                color: '#475569',
                fontWeight: '500'
              }}>
                {item.title}
              </div>
            </div>
          ))}
        </div>

        <div style={{ textAlign: 'left', marginTop: '30px' }}>
          <a href="#" style={{ color: '#004d99', fontWeight: '600', textDecoration: 'underline', fontSize: '1.1rem' }}>
            Download Blood Donation Camp Photos (ZIP)
          </a>
        </div>

      </div>
    </Layout>
  );
};

export default BloodDonationPage;
